import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as api from 'api/business/business';
import * as toastActions from 'state/toast/actions';
import {
  GET_ALL_BUSINESS,
  CHANGE_BUSINESS_FILTER,
  GET_EMPLOYEE_SLOTS,
  GET_EMPLOYEE_SLOTS_LOGS,
  GET_BUSINESS_DETAILS,
  CREATE_EMPLOYEE_SLOT,
  UPDATE_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS,
  UPDATE_BUSINESS_PACKAGE,
  GET_GOBIZ_LINKING,
  GET_OUTLETS,
  ADD_OUTLET_SLOT,
  GET_DEVICE_LOGS,
  GET_BILLING_HISTORY,
  UPDATE_OUTLET_SUBSCRIPTIONS,
  GET_FEATURE_SUBSCRIPTIONS,
  ACTIVATE_FEATURE_SUBSCRIPTIONS_OUTLET,
  GET_OUTLET_SLOTS,
  UPDATE_OUTLETS_SLOTS,
  GET_OUTLET_LOGS,
  GET_RECURRING_PAYMENTS_DETAILS,
  CANCEL_RECURRING_PAYMENT,
  GET_RECURRING_PAYMENT_TRANSACTIONS,
  GET_RECURRING_PAYMENT_HISTORY,
} from 'state/actionTypes';
import {
  creatingEmployeeSlot,
  getAllBusinessSuccess,
  getBusinessDetailsSuccess,
  getEmployeeSlotsLogsSuccess,
  getEmployeeSlotsSuccess,
  getGoBizLinkingSuccess,
  getPurchasedEmployeeSlotsSuccess,
  gettingAllBusiness,
  gettingBusinessDetails,
  gettingEmployeeSlots,
  gettingEmployeeSlotsLogs,
  gettingGoBizLinking,
  updatingBusinessPackage,
  updatingEmployeeSlotIsRenewableStatus,
  getDeviceLogsSuccessAction,
  loadingOutletsAction,
  getBillingHistorySuccessAction,
  getFeatureSubscriptionsSuccessAction,
  getOutletSlotsSuccessAction,
  getOutletsSuccessAction,
  updateOutletSubscriptionUIAction,
  loadingOutletLogsAction,
  getOutletLogsSuccessAction,
  gettingRecurringPaymentsDetails,
  getRecurringPaymentsDetailsSuccess,
  cancellingRecurringPayment,
  getRecurringPaymentTransactionSuccessAction,
  getRecurringPaymentHistorySuccessAction,
} from './actions';

export function* getAllBusiness({ payload }) {
  try {
    yield put(gettingAllBusiness(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetAllBusiness, payload);
    yield put(getAllBusinessSuccess({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get business data', error.message)
    );
  } finally {
    yield put(gettingAllBusiness(false));
  }
}

export function* getEmployeeSlots({ payload }) {
  try {
    yield put(gettingEmployeeSlots(true));
    const { data } = yield call(api.performGetEmployeeSlots, payload);
    yield put(getEmployeeSlotsSuccess(data));
    const purchasedEmployeeSLotsData = data.data.slots.filter(
      x => x.status === 'Purchased'
    );
    yield put(getPurchasedEmployeeSlotsSuccess(purchasedEmployeeSLotsData));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get employee slots', error.message)
    );
  } finally {
    yield put(gettingEmployeeSlots(false));
  }
}

export function* getEmployeeSlotsLogs({ payload }) {
  try {
    yield put(gettingEmployeeSlotsLogs(true));
    const { data } = yield call(api.performGetEmployeeSlotsLogs, payload);
    yield put(getEmployeeSlotsLogsSuccess(data));
  } catch (error) {
    yield put(
      toastActions.errorMessage(
        'Failed to get employee slots logs',
        error.message
      )
    );
  } finally {
    yield put(gettingEmployeeSlotsLogs(false));
  }
}

export function* getBusinessDetails({ payload }) {
  try {
    yield put(gettingBusinessDetails(true));
    const { data } = yield call(api.performGetBusinessDetails, payload);
    yield put(getBusinessDetailsSuccess(data));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get business profile', error.message)
    );
  } finally {
    yield put(gettingBusinessDetails(false));
  }
}

export function* getRecurringPaymentDetails({ payload }) {
  try {
    yield put(gettingRecurringPaymentsDetails(true));

    const { data } = yield call(api.performGetRecurringPaymentsData, payload);

    yield put(getRecurringPaymentsDetailsSuccess(data));
  } catch (error) {
    yield put(
      toastActions.errorMessage(
        'Failed to get recurring payments details',
        error.message
      )
    );
  } finally {
    yield put(gettingRecurringPaymentsDetails(false));
  }
}

export function* cancelRecurringPayment({ payload }) {
  try {
    const { onSuccess } = payload;

    yield put(cancellingRecurringPayment(true));

    yield call(api.performCancelRecurringPayment, payload);

    if (onSuccess) {
      onSuccess();
    }

    yield put(
      toastActions.successMessage(
        'Business recurring payment successfully cancelled'
      )
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage(
        'Failed to cancel business recurring payment',
        error.message
      )
    );
  } finally {
    yield put(cancellingRecurringPayment(false));
  }
}

export function* getRecurringPaymentTransactions({ payload }) {
  try {
    yield put(gettingBusinessDetails(true));

    const {
      data: { data, paging },
    } = yield call(api.performGetRecurringPaymentsTransactionsData, payload);
    yield put(getRecurringPaymentTransactionSuccessAction({ data, paging }));
  } catch (error) {
    yield put(getRecurringPaymentTransactionSuccessAction({}));
    yield put(
      toastActions.errorMessage(
        'Failed to get recurring payment transactions',
        error.message
      )
    );
  } finally {
    yield put(gettingBusinessDetails(false));
  }
}

export function* getRecurringPaymentHistory({ payload }) {
  try {
    yield put(gettingBusinessDetails(true));

    const {
      data: { data, paging },
    } = yield call(api.performGetRecurringPaymentsHistoryData, payload);

    yield put(getRecurringPaymentHistorySuccessAction({ data, paging }));
  } catch (error) {
    yield put(getRecurringPaymentHistorySuccessAction({}));
    yield put(
      toastActions.errorMessage(
        'Failed to get recurring payment history',
        error.message
      )
    );
  } finally {
    yield put(gettingBusinessDetails(false));
  }
}

export function* createEmployeeSlot({ payload }) {
  try {
    yield put(creatingEmployeeSlot(true));
    yield call(api.performCreateEmployeeSlot, payload);
    yield call(getEmployeeSlots, { payload });
    yield call(getEmployeeSlotsLogs, { payload });
    yield put(toastActions.successMessage('Employee slot successfully added'));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to add employee slot', error.message)
    );
  } finally {
    yield put(creatingEmployeeSlot(false));
  }
}

export function* updateEmployeeSlotIsRenewableStatus({ payload }) {
  try {
    yield put(updatingEmployeeSlotIsRenewableStatus(true));
    yield call(api.performUpdateEmployeeSlotIsRenewableStatus, payload);
    yield call(getEmployeeSlots, { payload });
    yield call(getEmployeeSlotsLogs, { payload });
    yield put(
      toastActions.successMessage('Employee slot successfully updated')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to update employee slot', error.message)
    );
  } finally {
    yield put(updatingEmployeeSlotIsRenewableStatus(false));
  }
}

export function* updateBusinessPackage({ payload }) {
  try {
    yield put(updatingBusinessPackage(true));
    yield call(api.performPatchBusinessPackage, payload);
    yield call(getBusinessDetails, { payload });
    yield put(
      toastActions.successMessage('Business package successfully updated')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage(
        'Failed to update business package',
        error.message
      )
    );
  } finally {
    yield put(updatingBusinessPackage(false));
  }
}

export function* getGoBizLinking({ payload }) {
  try {
    yield put(gettingGoBizLinking(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetOutlets, payload);
    yield put(getGoBizLinkingSuccess({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get GoBiz linking', error.message)
    );
  } finally {
    yield put(gettingGoBizLinking(false));
  }
}

export function* getOutlets({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetOutlets, payload);
    yield put(getOutletsSuccessAction({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get outlets', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* addOutletSlot({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    yield call(api.performAddOutletSlot, payload);
    yield put(
      toastActions.successMessage('Outlet slot has been successfully added')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to add outlet slot', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* getDeviceLogs({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    const {
      data: { data },
    } = yield call(api.performGetDeviceLogs, payload);
    yield put(getDeviceLogsSuccessAction({ data }));
  } catch (error) {
    yield put(getDeviceLogsSuccessAction({}));
    yield put(
      toastActions.errorMessage('Failed to get device logs', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* getBillingHistory({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    const {
      data: { data },
    } = yield call(api.performGetBillingHistory, payload);
    yield put(getBillingHistorySuccessAction({ data }));
  } catch (error) {
    yield put(getBillingHistorySuccessAction({}));
    yield put(
      toastActions.errorMessage('Failed to get billing history', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* updateOutletSubscriptions({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    yield call(api.performUpdateOutletSubscriptions, payload);
    yield put(updateOutletSubscriptionUIAction(payload));
    yield put(
      toastActions.successMessage('Successfully to update outlet subscriptions')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage(
        'Failed to update outlet subscriptions',
        error.message
      )
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* getFeatureSubscriptions({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetFeatureSubscriptions, payload);
    yield put(getFeatureSubscriptionsSuccessAction({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage(
        'Failed to get feature subscriptions',
        error.message
      )
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* activateFeatureSubscriptionsOutlet({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    yield call(api.performActivateFeatureSubscriptionsOutlet, payload);
    const featureSubscriptionsPayload = {
      businessId: payload.businessId,
      page: 1,
      size: 10,
    };
    yield call(getFeatureSubscriptions, {
      payload: featureSubscriptionsPayload,
    });
    yield put(
      toastActions.successMessage('Successfully to activate the feature')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to activate the feature', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* getOutletSlots({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    const {
      data: { data },
    } = yield call(api.performGetOutletSlots, payload);
    yield put(getOutletSlotsSuccessAction({ data }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get outlets slots', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* updateOutletsSlots({ payload }) {
  try {
    yield put(loadingOutletsAction(true));
    yield call(api.performUpdateOutletSlots, payload);
    const reloadPayload = {
      businessId: payload.business_id,
    };
    yield call(getOutletSlots, {
      payload: reloadPayload,
    });
    yield put(
      toastActions.successMessage('Successfully to update outlet slots')
    );
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to update outlet slots', error.message)
    );
  } finally {
    yield put(loadingOutletsAction(false));
  }
}

export function* getOutletLogs({ payload }) {
  try {
    yield put(loadingOutletLogsAction(true));
    const {
      data: { data, paging },
    } = yield call(api.performGetOutletLogs, payload);
    yield put(getOutletLogsSuccessAction({ data, paging }));
  } catch (error) {
    yield put(
      toastActions.errorMessage('Failed to get outlet logs', error.message)
    );
  } finally {
    yield put(loadingOutletLogsAction(false));
  }
}

export default function* saga() {
  yield takeEvery(GET_ALL_BUSINESS, getAllBusiness);
  yield takeEvery(CHANGE_BUSINESS_FILTER, getAllBusiness);
  yield takeEvery(GET_EMPLOYEE_SLOTS, getEmployeeSlots);
  yield takeEvery(GET_EMPLOYEE_SLOTS_LOGS, getEmployeeSlotsLogs);
  yield takeEvery(GET_BUSINESS_DETAILS, getBusinessDetails);
  yield takeEvery(GET_RECURRING_PAYMENTS_DETAILS, getRecurringPaymentDetails);
  yield takeEvery(CANCEL_RECURRING_PAYMENT, cancelRecurringPayment);
  yield takeEvery(GET_RECURRING_PAYMENT_HISTORY, getRecurringPaymentHistory);
  yield takeEvery(
    GET_RECURRING_PAYMENT_TRANSACTIONS,
    getRecurringPaymentTransactions
  );
  yield takeEvery(CREATE_EMPLOYEE_SLOT, createEmployeeSlot);
  yield takeEvery(
    UPDATE_EMPLOYEE_SLOT_IS_RENEWABLE_STATUS,
    updateEmployeeSlotIsRenewableStatus
  );
  yield takeEvery(UPDATE_BUSINESS_PACKAGE, updateBusinessPackage);
  yield takeEvery(GET_GOBIZ_LINKING, getGoBizLinking);
  yield takeLatest(GET_OUTLETS, getOutlets);
  yield takeLatest(ADD_OUTLET_SLOT, addOutletSlot);
  yield takeLatest(GET_DEVICE_LOGS, getDeviceLogs);
  yield takeLatest(GET_BILLING_HISTORY, getBillingHistory);
  yield takeLatest(UPDATE_OUTLET_SUBSCRIPTIONS, updateOutletSubscriptions);
  yield takeLatest(GET_FEATURE_SUBSCRIPTIONS, getFeatureSubscriptions);
  yield takeLatest(
    ACTIVATE_FEATURE_SUBSCRIPTIONS_OUTLET,
    activateFeatureSubscriptionsOutlet
  );
  yield takeLatest(GET_OUTLET_SLOTS, getOutletSlots);
  yield takeLatest(UPDATE_OUTLETS_SLOTS, updateOutletsSlots);
  yield takeLatest(GET_OUTLET_LOGS, getOutletLogs);
}
